<template>
  <div class="custom-input-container-horizontal">
    <label v-if="label" class="custom-input-label-horizontal">
      {{ label }}
    </label>

    <input
      class="custom-input"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [String, Number],
    placeholder: {
      type: String,
      default: "请输入",
    },
    label: String,
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.custom-input-container-horizontal {
  display: flex;
  align-items: center;
  gap: 12px;
}

.custom-input-label-horizontal {
  font-size: 12px;
  color: #333333;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  line-height: 100%;
}

.custom-input {
  min-width: 150px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  color: #9fa1a8;
  transition: border 0.3s;
  outline: none;
}

.custom-input:focus {
  border-color: #8e67ea;
}
</style>
